import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './components/footer/footer.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { DashboardComponent } from './pages/admin/dashboard/dashboard.component';
import { AssessmentCreateComponent } from './pages/admin/assessment-create/assessment-create.component';
import { DataTablesModule } from 'angular-datatables';
import { WardManageComponent } from './pages/admin/ward-manage/ward-manage.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AssessmentPrintComponent } from './pages/admin/assessment-print/assessment-print.component';
import { HoldingCardPrintComponent } from './pages/admin/holding-card-print/holding-card-print.component';
import { NgxPrintModule } from 'ngx-print';
import { QRCodeModule } from 'angularx-qrcode';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MultipleAssessmentCreateComponent } from './pages/admin/multiple-assessment-create/multiple-assessment-create.component';
import { AuthComponent } from './pages/auth/auth.component';
import { AdminComponent } from './pages/admin/admin.component';
import { LoginModule } from './pages/auth/login/login.module';
import { UnionManageComponent } from './pages/admin/union-manage/union-manage.component';
import { UnionsListComponent } from './pages/admin/unions-list/unions-list.component';
import { UnionSuspendedComponent } from './pages/union-suspended/union-suspended.component';
import { UnionMaintenanceComponent } from './pages/union-maintenance/union-maintenance.component';
import { ToastrModule } from 'ngx-toastr';
import { AuthService } from './services/auth.service';
import { AuthInterceptor } from './interceptor/auth.interceptor';
import { UpCardPrintComponent } from './pages/admin/up-card-print/up-card-print.component';
import { UsersStatusComponent } from './pages/users-status/users-status.component';
import { TaxCollectionComponent } from './pages/admin/tax-collection/tax-collection.component';
import { TaxCollectionListComponent } from './pages/admin/tax-collection-list/tax-collection-list.component';
import { QuickSmsServiceComponent } from './pages/admin/quick-sms-service/quick-sms-service.component';
import { AssessmentPageComponent } from './pages/admin/assessment-page/assessment-page.component';
import { ImageUploadComponent } from './pages/admin/image-upload/image-upload.component';
import { TaxCollectionReceiptComponent } from './pages/admin/tax-collection-receipt/tax-collection-receipt.component';
import { UserManagementComponent } from './pages/admin/user-management/user-management.component';
import { BulkTaxCollectionComponent } from './pages/admin/bulk-tax-collection/bulk-tax-collection.component';
import { ProfileSettingsComponent } from './pages/admin/profile-settings/profile-settings.component';

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    DashboardComponent,
    AssessmentCreateComponent,
    WardManageComponent,
    AssessmentPrintComponent,
    HoldingCardPrintComponent,
    MultipleAssessmentCreateComponent,
    AuthComponent,
    AdminComponent,
    UnionManageComponent,
    UnionsListComponent,
    UnionSuspendedComponent,
    UnionMaintenanceComponent,
    UpCardPrintComponent,
    UsersStatusComponent,
    TaxCollectionComponent,
    TaxCollectionListComponent,
    QuickSmsServiceComponent,
    AssessmentPageComponent,
    ImageUploadComponent,
    TaxCollectionReceiptComponent,
    UserManagementComponent,
    BulkTaxCollectionComponent,
    ProfileSettingsComponent
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    AppRoutingModule,
    DataTablesModule,
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    NgxPrintModule,
    QRCodeModule,
    NgbModule,
    MatDatepickerModule,
    MatFormFieldModule,
    ToastrModule.forRoot(),
  ],
  providers: [
    AuthService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
